import V4API from '../../api/V4client';
import {mapV4BeaconToV3, v3BeaconToV4Body} from './transforms';

const getField = (beacon, key) => (beacon?.get ? beacon.get(key) : beacon?.[key]);

// `sites` must be the same account's, or a beacon can bind to another account's plan.
// Returns null on failure, not [], so the grid isn't blanked as if the account had none.
export async function fetchV4Beacons(scope, sites, accountNames = {}) {
    try {
        const res = await V4API.beaconsList(scope);
        return (res?.data || [])
            .filter(b => b?.id)
            .map(b => mapV4BeaconToV3(b, sites, accountNames[b.owner_id] || ''));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch V4 beacons', e?.response?.status, e?.response?.data || e);
        return null;
    }
}

// Throws on failure.
export async function fetchV4Beacon(id, scope, sites, accountNames = {}) {
    const res = await V4API.beaconsDetail(id, scope);
    const beacon = res?.data;
    if (!beacon?.id) throw new Error('no beacon in the response');
    return mapV4BeaconToV3(beacon, sites, accountNames[beacon.owner_id] || '');
}

export async function saveV4Beacon(beacon, sites, scope) {
    const body = v3BeaconToV4Body(beacon, sites);
    const id = getField(beacon, 'uuid') || getField(beacon, 'id');
    const isNew = !id || id === 0;
    const res = isNew
        ? await V4API.beaconsCreate(body, scope)
        : await V4API.beaconsUpdate(id, body, scope);
    return res?.data;
}

export async function deleteV4Beacon(beacon, scope) {
    const id = getField(beacon, 'uuid') || getField(beacon, 'id');
    if (!id) return;
    await V4API.beaconsDelete(id, scope);
}
